const fieldValidation = {
  required: '{{fieldName}} 是必須的',
  maxLength: '最多 {{value}} 字元',
  pattern: '{{fieldName}} 無效',
};

export default fieldValidation;
